import React, { useEffect } from "react";
import styles from "./MisProyectos.module.scss";
import { connect } from "react-redux";
import {
    getProjects,
    closeMainModal,
} from "../../../../store/actions/index";
import { motion } from "framer-motion";
import ProfileEmptyState from "../ProfileEmptyState/ProfileEmptyState.tsx";
import { useActionGuard } from "../../../../hooks/useActionGuard.ts";
import ProjectCardWithLogic from "./ProjectCardWithLogic.tsx";
import { useNavigate } from "react-router-dom";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";


const MisProyectos = ({
    proyectos,
    proyectosLoading,
    perfilAjeno,
    closeMainModal,
    getProjects,
    myPerson,
    userData,
    setInfoReady,
    currentTab,
    gestionNavSection,
    ...props
}) => {
    const navigate = useNavigate();

    useEffect(() => {
        getProjects(myPerson ? userData.id : perfilAjeno);
    }, [userData.id, perfilAjeno]);

    useEffect(() => {
        if (!proyectosLoading && proyectos !== undefined) {
            setInfoReady(true);
        }
    }, [proyectosLoading, proyectos, setInfoReady]);

    const { guard } = useActionGuard()

    const proyectosToMap = proyectos?.filter((proyecto) => proyecto.type === "PRIVATE");

    const handleNewOpenProject = () => {
        navigate("/obrasprivadas/crear");
        closeMainModal();
    };

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}
        >
            {proyectosLoading ? (
                <div className={styles.loadingContainer}>
                    <RegisteredUserProfileLoader />
                </div>
            ) : (
                proyectos && proyectosToMap.length > 0 ? (
                    <div className={styles.container_body}>
                        {proyectosToMap.map((proyecto) => (
                            <ProjectCardWithLogic
                                key={proyecto.id}
                                project={proyecto}
                                myPerson={myPerson}
                                userData={userData}
                                currentTab={currentTab}
                                gestionNavSection={gestionNavSection}
                            />
                        ))}
                    </div>
                ) : (
                    myPerson ? (
                        <ProfileEmptyState
                            illustration="projects"
                            title="No tenés proyectos privados publicados"
                            description="Creá tu primer proyecto para recibir cotizaciones de profesionales en Edify."
                            onRootClick={guard("quote_project", handleNewOpenProject)}
                        />
                    ) : (
                        <ProfileEmptyState
                            illustration="projects"
                            title="Este perfil no tiene proyectos privados publicados"
                            description="Cuando publique obras privadas, las vas a ver en esta sección."
                        />
                    )
                )
            )}
        </motion.section>
    );
};

const mapStateToProps = (state) => {
    return {
        proyectos: state.profile.proyectos,
        proyectosLoading: state.profile.proyectosLoading,
    };
};

export default connect(mapStateToProps, {
    getProjects,
    closeMainModal,
})(MisProyectos);







